import { css, Theme } from "@emotion/react";

export const UserLayoutStyle = {
  self: css`
    //
    min-height: 100%;
  `,

  contentWrapper: (background: string) => css`
    display: flex;
    gap: 28px;
    padding: 90px 32px 24px;
    background-image: url(${background});
    background-repeat: no-repeat;
    background-size: 100% 250px;
    min-width: 1200px;
    min-height: calc(100dvh - 75px - 247px);
  `,

  mainContent: ({ colors }: Theme) => css`
    flex: 1;
  `,
};
